module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "12px"
    }
  }, [_c('tinymce-editor', {
    attrs: {
      "api-key": "API_KEY",
      "init": {
        plugins: 'wordcount'
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a07b2268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tinymce/index.vue
// module id = 1193
// module chunks = 2